












import { Component, Vue, Prop,Emit } from 'vue-property-decorator';
import * as Components from '@/agiles/components';

@Component
export default class FilterBox extends Vue {

  @Prop({default:''}) public title?: string;
  @Prop({default:null}) public value?: string;
  @Prop({default:''}) public placeholder?: string;
  @Prop({ default: null }) public nullValue: any;
  @Prop({ default: false }) public isNumber: boolean;
  @Prop() public tooltip: string;

  public get internalValue(): string {
    return this.value;
  }
  
  @Emit('click')
  public OnClick() {}

  public set internalValue(value: string) {
    //数値フラグONで数値に変換できない場合にnullValueをセット
    if (this.isNumber && isNaN(Number.parseFloat(value))){
      this.$emit('update:value', this.nullValue);
    } else {
      // 親コンポーネント側で更新
      this.$emit('update:value', value);
    }

  }
}

